<section class="section" mat-dialog-content>
  <img
    src="../../.././../assets/img/AdobeStock_498410164.jpeg"
    alt="Aircall image"
  />
  <form id="weCallYouForm" [formGroup]="airCallFormGroup">
    <button type="button" class="close" (click)="dialogRef.close()">
      <i class="fa-solid fa-xmark"></i>
    </button>
    <div class="row-space-title">
      <span class="title-modal" translate
        >components.weCallYouComponent.title</span
      >
    </div>
    <ng-container *ngIf="!isLoading">
      <div class="col-md-12">
        <div class="row">
          <div class="form-group col-md-12">
            <label class="subtitle mandatory" translate>
              components.weCallYouComponent.whatDoYouWantToDo
            </label>
            <mat-radio-group
              formControlName="do_you_invest_in"
              style="display: flex; flex-direction: column"
            >
              <mat-radio-button color="primary" [value]="'Quiero invertir'">
                <span class="checkboxes" translate
                  >components.weCallYouComponent.wantToInvest</span
                >
              </mat-radio-button>
              <mat-radio-button
                color="primary"
                [value]="'Quiero vender un inmueble alquilado'"
              >
                <span class="checkboxes" translate>
                  components.weCallYouComponent.wantToSellRentedProperty
                </span>
              </mat-radio-button>
            </mat-radio-group>
          </div>
        </div>
        <div class="row">
          <div class="form-group col-md-4">
            <label class="subtitle mandatory" translate
              >components.weCallYouComponent.countryCode</label
            >
            <app-countries-autocomplete
              [control]="airCallFormGroup.get('code_country')"
            ></app-countries-autocomplete>
          </div>
          <div class="form-group col-md-8 py-sm-0">
            <label class="subtitle row-space">
              <span class="mandatory" translate
                >components.weCallYouComponent.phone</span
              >
            </label>
            <input
              type="text"
              appMaxLength
              [maxLength]="10"
              class="form-control"
              formControlName="phone_number"
              id="phone_number"
            />
          </div>
        </div>
        <div class="row">
          <div class="form-group col-md-6 col-sm-12">
            <label class="subtitle mandatory" translate
              >components.weCallYouComponent.firstName</label
            >
            <input
              type="text"
              class="form-control"
              formControlName="first_name"
              id="first_name"
            />
          </div>
          <div class="form-group col-md-6 col-sm-12">
            <label class="subtitle mandatory" translate
              >components.weCallYouComponent.lastName</label
            >
            <input
              type="text"
              class="form-control"
              formControlName="last_name"
              id="last_name"
            />
          </div>
        </div>

        <div class="row">
          <div class="form-group col-md-12">
            <label class="subtitle mandatory" translate
              >components.weCallYouComponent.email</label
            >
            <input
              type="email"
              class="form-control"
              formControlName="email"
              id="email"
            />
          </div>
        </div>

        <div class="row">
          <div class="form-group col-md-12">
            <mat-checkbox formControlName="terms" [color]="'primary'">
              <span class="mandatory checkboxes" style="white-space: initial">
                {{ "components.venderPortal.acceptTerms" | translate }}
                <a
                  [routerLink]="[
                    (translateService.currentLang === 'es' ? '/es' : '/en') +
                      '/terminos-condiciones'
                  ]"
                  target="_blank"
                >
                  {{ "components.registro.termsAndConditions" | translate }}
                </a>
                y
                <a
                  [routerLink]="[
                    (translateService.currentLang === 'es' ? '/es' : '/en') +
                      '/politica-de-privacidad'
                  ]"
                  target="_blank"
                >
                  {{ "components.registro.privacyPolicies" | translate }}</a
                >
              </span>
            </mat-checkbox>
          </div>
        </div>

        <div class="row">
          <div class="form-group col-md-12">
            <mat-checkbox formControlName="receive_info" [color]="'primary'">
              <span style="white-space: initial" class="checkboxes">
                {{ "components.encubierto.receiveShortInfo" | translate }}
              </span>
            </mat-checkbox>
          </div>
        </div>

        <div class="alert alert-danger" role="alert" *ngIf="errorMessage">
          <i class="fas fa-exclamation-triangle"></i> &nbsp;&nbsp;
          <span translate>{{ errorMessage }}</span>
        </div>
      </div>
      <div mat-dialog-actions class="start">
        <button
          id="btn-callmeback-agent"
          class="yellow-btn"
          cdkFocusInitial
          (click)="sendHubspotData()"
          [disabled]="airCallFormGroup.invalid"
        >
          <span translate>components.weCallYouComponent.send</span>
        </button>
      </div>
    </ng-container>

    <div
      class="text-center col-12"
      style="padding: 20px 0 30px 0; margin-top: 10% !important"
      *ngIf="isLoading"
    >
      <app-spinner></app-spinner>
    </div>
  </form>
</section>
